import OrderTable from '@accounting/components/tables/order-table/order-table.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'bpc-profile-orders',
  components: {
    'bpc-order-table': OrderTable,
  },
})
export default class ProfileOrders extends Vue {
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
